import React, { useContext, useEffect, useState } from "react";
import { Box, Tab } from "@material-ui/core";
import useStyles from "./styles";
import { TabContext, TabList, TabPanel } from "@material-ui/lab";
import { StoreInventory } from "./StoreInventory";
import { StoreEvents } from "./StoreEvents";
import { StoreDistributors } from "./StoreDistributors";
import { Store } from "../../../../models/Store";
import { hasRole } from "../../../../models/User";
import { permissions } from "../../../../constants";
import { UserContext } from "../../../../UserProvider";
import { StocktakingList } from "./stocktaking/StocktakingList";
import { useI18n } from "../../../../hooks/useI18n";

interface StoreDetailsProps {
  store: Store;
  onTabSelect: (tab: string) => void;
  activeTab: string;
}

const StoreDetails = ({ store, onTabSelect, activeTab }: StoreDetailsProps) => {
  const classes = useStyles();
  const user = useContext(UserContext);
  const isDistributorManager = hasRole(user, ["DistributorManager"]);
  const { t } = useI18n();

  const [selectedTab, setSelectedTab] = useState(activeTab ?? "products");

  const handleChange = (event: React.ChangeEvent<{}>, newValue: string) => {
    setSelectedTab(newValue);
    onTabSelect(newValue);
  };

  return (
    <TabContext value={selectedTab}>
      {isDistributorManager ? (
        <TabList
          onChange={handleChange}
          className={classes.tabHeader}
          TabIndicatorProps={{ className: classes.indicator }}
        >
          <Tab
            label={t("common.messages.activatedProducts")}
            value="products"
            className={classes.tabEntry}
          />
        </TabList>
      ) : (
        <TabList
          onChange={handleChange}
          className={classes.tabHeader}
          TabIndicatorProps={{ className: classes.indicator }}
        >
          <Tab
            label={t("common.messages.activatedProducts")}
            value="products"
            className={classes.tabEntry}
          />
          <Tab label={"Events"} value="events" className={classes.tabEntry} />
          <Tab
            label={"Distributors"}
            value="distributors"
            className={classes.tabEntry}
          />
          <Tab
            disabled={!hasRole(user, permissions.stores)}
            label={"Stocktaking"}
            value="stocktaking"
            className={classes.tabEntry}
          />
        </TabList>
      )}

      <TabPanel value="products" className={classes.tabPanel}>
        <StoreInventory store={store} />
      </TabPanel>
      <TabPanel value="events" className={classes.tabPanel}>
        <StoreEvents store={store} />
      </TabPanel>
      <TabPanel value="distributors" className={classes.tabPanel}>
        <StoreDistributors store={store} />
      </TabPanel>
      <TabPanel value="stocktaking" className={classes.tabPanel}>
        <StocktakingList store={store} />
      </TabPanel>
    </TabContext>
  );
};
export default StoreDetails;
